<template>
  <section>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <br />
    <div class="sso-login-container box">
      <!-- <div class="shdw is-paddingless wdt ubuntu" style=""> -->
      <div class="">
        <br />
        <b-field placeholder="Email">
          <b-input
            v-model="email"
            placeholder="Email"
            name="email"
            data-test="email_input"
          ></b-input>
        </b-field>
        <b-message
          v-if="error"
          type="is-danger"
          aria-close-label="Close message"
          data-test="error_message"
        >
          {{ errorMsg }}
        </b-message>
        <b-button
          size="is-medium"
          type="is-gant"
          class="ubuntu"
          @click="locateIdpByEmail"
          data-test="login_button"
          expanded
        >
          <h5>Log in with SSO</h5>
        </b-button>

        <div class="conditions mt-4">
          <p class="text-center ubuntu">
            <a @click="goToLoginPage">Log in with TripCircuit instead</a>
          </p>
        </div>
        
      </div>
    </div>
    <br />
  </section>
</template>

<script>
export default {
  name: "Sso",
  data() {
    return {
      email: null,
      tripcircuit_domain: null,
      access_token: "",
      loginUrl: null,
      error: false,
      errorMsg: "Login Failed",
      loading: false,
    };
  },
  computed: {},
  methods: {
    goToLoginPage() {
      this.$router.push({ path: "/login" });
    },
    // Locate IdP by TripCircuit hostname
    locateIdpByHostname() {
      let path = "saml/idp-locator";

      let body = {};

      let hostname = window.location.hostname;

      body.tripcircuit_domain = hostname;

      console.log(hostname);

      this.$app.huddleLabsServerCall(path, body).then((result) => {
        if (!result.errors && result.data.config.singleSignOnServiceUrl) {
          this.loginUrl = result.data.config.singleSignOnServiceUrl;
        }

        console.log(this.loginUrl);

        if (this.loginUrl) {
          return window.location = this.loginUrl;
        } 
      });
    },
    // Locate IdP by email address
    locateIdpByEmail() {
      let path = "saml/idp-locator";

      let body = {};

      if (this.email) {
        body.email = this.email;
      }

      if (this.tripcircuit_domain) {
        body.tripcircuit_domain = this.tripcircuit_domain;
      }


      this.$app.huddleLabsServerCall(path, body).then((result) => {
        if (!result.errors && result.data.config.singleSignOnServiceUrl) {
          this.loginUrl = result.data.config.singleSignOnServiceUrl;
        }

        console.log(this.loginUrl);

        if (this.loginUrl) {
          return window.location = this.loginUrl;
        } 
        
        return this.$router.push({ path: "/login" });
      });
    },
  },
  mounted() {
    this.locateIdpByHostname()
  },
};
</script>

<style scoped>
.sso-login-container {
  max-width: 90%;
  width: 500px;
  margin: auto;
}
</style>
